import {Grid , Typography , ImageList, ImageListItem, ImageListItemBar ,  IconButton} from '@mui/material';
import '../App.css';
import GitHubIcon from '@mui/icons-material/GitHub';
import { HashLink as Link } from 'react-router-hash-link';
import img1 from '../assets/school.jpg' ;
import img2 from '../assets/soundcloud.png' ;
import img3 from '../assets/plants.png' ;
import img4 from '../assets/weather.png' ;
import img5 from '../assets/ecommerce.png' ;

function Projects(){


    const imgData = [
        {
            img : img1 ,
            title  : 'School Management System Desktop App' ,
            description : 'Desktop App built with javaFx' , 
            url : '//www.github.com/nadircode/School-Management-System-JavaFX'
        },
        {
            img : img2 ,
            title  : 'Cloning Soundcloud website ' ,
            description : 'cloning with html and css',
            url : '//www.github.com/nadircode/Soundcloud_home_page-clone'
        },
        {
            img : img3 ,
            title  : 'Plants website ' ,
            description : 'build with html , css and javascript',
            url : '//www.github.com/nadircode/Plants-Website-Home-Page'
        },
        {
            img : img4 ,
            title  : 'small weather website' ,
            description : 'small weather website built with react JS and openweathermap API' ,
            url :'//www.github.com/nadircode/React-Weather-App'
        },
        {
            img : img5 ,
            title  : 'E-Commerce Website' ,
            description : 'E-commerce website built with React JS , Express js and MySQL',
            url : '//www.github.com/nadircode/mini-study-project'
        }
    ]
    return(
        
      <Grid container style = {{marginTop : '4em'}} id="projects">
        <Grid item xs={12}>
                        <Typography variant="h5" component='div' 
                            style={{textAlign : 'center'}}
                        >
                            PROJECTS 
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography  component='div' 
                            style={{textAlign : 'center' , color : "#a1a1a1"}}
                        >
                            Projects i worked on
                        </Typography>
                    </Grid>

                    <Grid container spacing={0} marginTop='4em'>
                        <ImageList cols={2} >
                            {imgData.map((item)=>(
                                <ImageListItem key={item.img}>
                                    <img
                                        src={`${item.img}`}
                                        srcSet={`${item.img}`}
                                        alt={item.title}
                                        loading="lazy"
                                    />
                                    <ImageListItemBar
                                        title={item.title}
                                        subtitle={item.description}
                                        actionIcon={
                                            <Link to={item.url} target='_blank'>
                                            <IconButton 
                                                aria-label="Github Account"
                                                style={{
                                                color : 'white' 
                                                }}
                                            >
                                                <GitHubIcon style={{fontSize : '2em'}}/>
                                            </IconButton>
                                        </Link>
                                        }
                                     />
                                </ImageListItem>
                            ))}
                        </ImageList>
                    </Grid>

      </Grid>
    )
}

export default Projects;